import { Plan } from '@models/membership/Plan'
import { useAppSelector } from '@store/hooks'
import { selectSelectedCoupon } from '@store/membership/CouponReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRM, SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import { Alert, Form, Input, InputNumber } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedCoupon())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>

      <SBRM.FormSection section="maxUsage">
        <Form.Item
          name="maxUsage"
          rules={[]}
          label={'Maximum usage'}
          initialValue={1}
        >
          <InputNumber className="w-full" min={item.usage} />
        </Form.Item>
        <Alert
          type="warning"
          title={`The code has currently been ${item.usage} used times`}
          style={{ marginBottom: '24px' }}
        />
      </SBRM.FormSection>

      <SBRM.FormSection section="plans">
        <Form.Item label={'Plans'} name="plans" rules={[requiredRule()]}>
          <SBAsyncSelect<Plan>
            entity={Entity.membershipPlan}
            multiple
            allowClear
          />
        </Form.Item>
      </SBRM.FormSection>
    </Form>
  )
}

export default Update
